module.exports = __webpack_public_path__ + "static/AutoPolicyUpdatesDesktop-413d562e75c0ec811da3a7202b17c22d.png";